import {inject, Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {finalize, Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {HttpLoadingActions} from '@aviary/store/http-loading/http-loading.actions';
import {BYPASS_LOADING} from '@aviary/store/http-loading/http-loading.types';

@Injectable({
  providedIn: 'root'
})
export class HttpLoadingInterceptor implements HttpInterceptor {
  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.context.get(BYPASS_LOADING)) return next.handle(request);

    this.store.dispatch(HttpLoadingActions.requestStarting());

    return next.handle(request).pipe(
      finalize(() => this.store.dispatch(HttpLoadingActions.requestComplete()))
    );
  }

  private store: Store = inject(Store);
}
